export enum FunctionalityType {
    MotionDetection = 0,
    Recording = 1,
    FlameDetection = 2,
    Monitoring = 3,
    Care = 4,
}
